// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import entityFieldEntity from './entities/entity-field.json';
import entityFieldMenu from '../pages/entity-field/menu.json';
import entityFieldFullForm from '../pages/entity-field/forms/full.json';
import entityFieldContextForm from '../pages/entity-field/forms/context.json';
import entityFieldMiniForm from '../pages/entity-field/forms/mini.json';
import entityFieldLookupForm from '../pages/entity-field/forms/lookup.json';
import entityFieldTableView from '../pages/entity-field/views/table.json';
import entityFieldCardsView from '../pages/entity-field/views/cards.json';
import entityFieldDashboardView from '../pages/entity-field/views/dashboard.json';

/** Тип запису «Поле сутності» зі сторінками пакета: меню, форми та подання з pages/entity-field/. */
export const entityFieldDefinition: IRecordTypeDefinition = {
  ...entityFieldEntity,
  views: assembleViewSet({
      table: entityFieldTableView,
      cards: entityFieldCardsView,
      dashboard: entityFieldDashboardView,
  }),
  form: entityFieldFullForm,
  forms: { full: entityFieldFullForm, context: entityFieldContextForm, mini: entityFieldMiniForm, lookup: entityFieldLookupForm },
  menu: entityFieldMenu,
} as IRecordTypeDefinition;
